import { createContext } from "react";
import { IBusiness } from "@/business/business";

interface BusinessContextType {
  // Data
  businesses: IBusiness[];
  selectedBusinessId: string | null; // The user-selected business ID (for tenant users)
  businessId: string | null; // The effective business ID (selected for tenant or parentable_id for business users)
  isLoading: boolean;
  isError: boolean;
  isTenantUser: boolean;
  // Actions
  selectBusiness: (businessId: string) => void;

  // The selected business object based on the effective businessId and businesses list
  selectedBusiness: IBusiness | undefined;
}

const BusinessContext = createContext<BusinessContextType | null>(null);

export default BusinessContext;
